var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative"}},[_c('div',{on:{"click":function($event){return _vm.toSearch()}}},[_c('van-sticky',[_c('van-search',{attrs:{"readonly":"","shape":"round","placeholder":_vm.module.style.text,"background":_vm.module.style.bgcolor}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }